// This enum mirrors the NotificationTypes enum in the backend
export enum NotificationTypes {
  POST = 'POST',
  LIKE = 'LIKE',
  REPOST = 'REPOST',
  FOLLOW = 'FOLLOW',
  REPLY = 'REPLY',
  MENTION = 'MENTION',
  PORTFOLIOLIKE = 'PORTFOLIOLIKE',
  PORTFOLIOCOMMENT = 'PORTFOLIOCOMMENT',
  PORTFOLIOFAVORITE = 'PORTFOLIOFAVORITE',
  PORTFOLIOREPOST = 'PORTFOLIOREPOST',
  PRICECHANGE = 'PRICECHANGE',
  ADDEDTOPORTFOLIO = 'ADDEDTOPORTFOLIO',
  PORTFOLIOACTION = 'PORTFOLIOACTION',
  LEAGUEINVITE = 'LEAGUEINVITE',
  LEAGUERANKCHANGE = 'LEAGUERANKCHANGE',
  PRIVATEMESSAGE = 'PRIVATEMESSAGE',
  ORDERCOMPLETED = 'ORDERCOMPLETED',
}
